import { ActiveFilter } from '@epicuro-next/models/filters';
import { OrderFilterId } from '@epicuro-next/models/order-book';
import { yearsEqual } from '@epicuro-next/utilities';

export function getUpdatedSelectedFilters(
  { id, values }: ActiveFilter,
  prevSelectedFilters: ActiveFilter[],
): ActiveFilter[] {
  let newSelectedFilters = prevSelectedFilters.filter(
    (selectedFilter) => selectedFilter.id !== id,
  );

  if (values?.length) {
    newSelectedFilters.push({ id, values });

    if (id === OrderFilterId.Brand) {
      newSelectedFilters = newSelectedFilters.filter(
        (f) => f.id !== OrderFilterId.SubBrand,
      );
    }

    if (id === OrderFilterId.Year) {
      const monthFilterIndex = newSelectedFilters.findIndex(
        (f) => f.id === OrderFilterId.Month,
      );
      if (monthFilterIndex > -1) {
        const validValues = newSelectedFilters[monthFilterIndex].values.filter(
          (monthValue) =>
            values.some((yearValue) =>
              yearsEqual(new Date(yearValue), new Date(monthValue)),
            ),
        );
        newSelectedFilters.splice(monthFilterIndex, 1, {
          id: OrderFilterId.Month,
          values: validValues,
        });
      }
    }
  }

  return newSelectedFilters;
}
